import React, { useState } from 'react'
import { Modal as AntModal, Form } from 'antd'
import { Button } from "./Button";
import styleStudio from './modal.module.sass';
import styleFlow from './modalFlow.module.sass';
import CodeEditor, { IProps as CodeEditorProps } from "../CodeEditor2";
import ExportDocument, { IProps as ExportDocumentProps } from "../../ExportDocument";

type Footer = {
    enable: true,
    okText: string,
    cancelText: string,
    onOk: any
} | {
    enable: false
}

type DeleteOptions = {
    validateString: string | undefined,
    type: string,
    terms?: string[],
}

interface IProps {
    id?: string,
    title?: any,
    onCancel: any,
    unmountOnCancel: boolean,
    visible: boolean,
    footer: Footer,
    deleteOptions?: DeleteOptions,
    closable?: boolean,
    width?: string,
    children?: any,
    from: string,
    codeEditorProps?: CodeEditorProps,
    exportDocumentProps?: ExportDocumentProps,
}

export const Modal = (props: IProps) => {

    const style = (props.from === 'studio') ? styleStudio : styleFlow
    const color = (props.deleteOptions) ? 'shadow-secondary' : 'shadow-primary'
    const [error, setError] = useState<boolean>(false)

    let callbackFromEditor: any;

    const handleOk = async () => {
        if (props.deleteOptions) {
            setError(false)
            props.footer && props.footer.enable && props.footer.onOk()
        } else if (props.codeEditorProps) {
            const shouldClose = callbackFromEditor && await callbackFromEditor()
            if (!shouldClose) {
                props.footer && props.footer.enable && props.footer.onOk()
            }
        }
        else {
            props.footer && props.footer.enable && props.footer.onOk()
        }
    }

    return (
        <AntModal
            key={props.id}
            className={`override-modal${(props.from !== 'studio') ? '-flow' : ''}`}
            title={props.title}
            onCancel={props.onCancel}
            destroyOnClose={props.unmountOnCancel}
            closable={props.closable}
            width={props.width}
            maskClosable={false}
            footer={props.footer.enable ?
                [
                    <>
                        <Button color="light" size="small" onClick={props.onCancel} from={props.from}>
                            {props.footer.cancelText}
                        </Button>
                        <Button color={color} size="small" onClick={handleOk} from={props.from}>
                            {props.footer.okText}
                        </Button>
                    </>
                ]
                :
                null
            }
            visible={props.visible}
        >
            {
                (props.deleteOptions) ?
                    <div className={style.deleteContainer}>
                        <Form>
                            <Form.Item
                                validateStatus={error ? "error" : undefined}
                            >
                                <div className={style.confirmation} style={{ fontSize: "25px !important", fontWeight: 600 }}>{`Are you sure you want to delete this document?`}</div>
                            </Form.Item>
                        </Form>
                        {
                            (props.deleteOptions.terms && props.deleteOptions.terms.length > 0) ?
                                <div className={style.terms}>
                                    <div className={style.termsHeader}>This change is irreversible</div>
                                    <ul className={style.termsItemContainer}>
                                        {props.deleteOptions.terms.map((item: string) => {
                                            return <li className={style.termsItem}>{item}</li>
                                        })}
                                    </ul>
                                </div>
                                :
                                null
                        }

                    </div>
                    :
                    (props.codeEditorProps) ?
                        <CodeEditor {...props.codeEditorProps} editorCallback={(callback: any) => {
                            callbackFromEditor = callback
                        }} />
                        :
                        props.children

            }
            {props.exportDocumentProps && <ExportDocument {...props.exportDocumentProps} />}
        </AntModal>
    )
}
